module.exports = __webpack_public_path__ + "static/media/HurricanePike.8d8d258d.png";